import sanitizeHTML from 'sanitize-html';

export default function sanitize(text) {
    return sanitizeHTML(text, {
        allowedTags: sanitizeHTML.defaults.allowedTags.concat(['img', 's', 'h1', 'h2']),
        allowedAttributes: {
            'img': ['src', 'style'],
            'a': ['href', 'name', 'target'],
            '*': ['class', 'height', 'width', 'data-*', 'style'],
            'table': ['align', 'border', 'cellpadding', 'cellspacing'],
            'td': ['colspan'],
            'th': ['colspan'],
            'iframe': ['src', 'allowfullscreen', 'frameborder', 'tabindex'],
            'ol': ['start']
        },
        allowedSchemesByTag: {
            a: ['http', 'https', 'mailto', 'tel']
        }
    });
}
